import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { rate } from "../../slices/commentSlice";
import { connect } from "react-redux";

class Rating extends Component {

    constructor(props) {
        super(props);

        this.state = {
            stars: [],
            rating: this.props.starts,
            change:this.props.change,
            size:this.props.size,
            color:this.props.color,
            hovered: 0,
            selectedIcon: "★",
            deselectedIcon: "☆"
        };

        let outOf = props.outOf ? props.outOf : 5;

        for (var i = 0; i < outOf; i++) {
            this.state.stars.push(i + 1);
        }
    }

    changeRating(newRating) {
        if (this.state.change) {
            this.setState({
                rating: newRating
            });
            this.props.dispatch(rate(newRating))
        }

        if (this.props.onChange){
            this.props.onChange(newRating);
            this.props.dispatch(rate(newRating))}
    }

    hoverRating(rating) {
        if (this.state.change) {
            this.setState({
                hovered: rating
            });
        }
    }

    render() {

        const { stars, rating, hovered, deselectedIcon, selectedIcon } = this.state;
        return (
            <>
                <div className="rating " style={{  color: this.props.color ,top : this.props.top}}>

                    {stars.map(star => {
                        return (
                            <span className="span-rating"
                                style={{ cursor: 'pointer'  ,fontSize:this.state.size,  color:this.props.color || "gold" ,bottom:this.props.bottom,top: "-5px"  }}
                                onClick={() => { this.changeRating(star) }}
                                onMouseEnter={() => { this.hoverRating(star); }}
                                onMouseLeave={() => { this.hoverRating(0); }}
                            >
                                {rating < star ?
                                    hovered < star ? deselectedIcon : selectedIcon
                                    :
                                    selectedIcon
                                }
                            </span>
                        );
                    })}


                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {}
  }
  
  //connect function INJECTS dispatch function as a prop!!
  export default withRouter(connect(mapStateToProps)(Rating));
  